

















































// @ts-ignore
import v8n from 'v8n';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { BusTrip, ApiError } from '@/api';
import { snackModule } from '@/store';
import { Route } from 'vue-router';
import ConfirmDialog from '@/components/admin/ConfirmDialog.vue';
import TimePicker from '@/components/TimePicker.vue';

@Component({
  components: {
    ConfirmDialog,
    TimePicker,
  },
})
export default class extends Vue {
  @Prop({ required: false }) readonly routeTitle: string;

  loading: boolean = false;
  valid: boolean = false;
  complete: boolean = false;
  error: string = '';

  busTrip: BusTrip | null = null;

  timetable: Array<{
    text: string | number | object;
    value: string | number | object;
    disabled?: boolean;
    divider?: boolean;
    header?: string;
  }> = [
    { text: 'Weekday', value: 'weekday' },
    { text: 'Weekend', value: 'weekend' },
  ];

  nextFn: (() => void) | null = null;
  leaveConfirmDialog: boolean = false;
  confirmLeaveContent: string =
    'Are you sure you would like to leave? Any unsaved changes will be lost.';

  requiredString = [
    (v: string) =>
      v8n()
        .string()
        .not.empty()
        .test(v) || 'This field is required',
  ];

  get busTripId() {
    return this.$route.params.busTripId;
  }

  back() {
    this.$router.back();
  }

  beforeRouteLeave(to: Route, from: Route, next: (args?: any) => void) {
    if (this.busTrip && this.busTrip.isDirty()) {
      this.nextFn = next;
      this.leaveConfirmDialog = true;
      next(false);
    } else {
      next();
    }
  }

  leave() {
    if (this.nextFn) {
      this.nextFn();
    }
  }

  async save() {
    if (!this.busTrip) {
      return;
    }

    try {
      await this.busTrip.save();
      if (
        this.$route.name === 'admin-bustrips-add' &&
        this.busTrip &&
        this.busTrip.id
      ) {
        this.$router.push({
          name: 'admin-bustrips-edit',
          params: { busTripId: this.busTrip.id },
        });
        snackModule.showSnackbar('Bus Trip Created');
      } else {
        snackModule.showSnackbar('Bus Trip Updated');
      }
    } catch (err) {
      err.response.errors.forEach((e: ApiError) =>
        snackModule.showSnackbar(e.detail),
      );
    }
  }

  async mounted() {
    if (this.$route.name === 'admin-bustrips-edit' && this.busTripId) {
      try {
        this.busTrip = (await BusTrip.find(this.busTripId)).data;
      } catch (err) {
        // most likely this means not found
        snackModule.showSnackbar('Bus Trip not found');
      }
    } else {
      this.busTrip = new BusTrip();
    }
  }
}
